import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import App from './App.tsx'
import { AuthProvider } from './features/auth/AuthContext.tsx'
import { initGTM } from './lib/analytics/gtm.ts'
import { initUtm } from './lib/analytics/utm.ts'

// Analytics — init avant le render pour capter les UTM de l'URL
// d'entrée et envoyer le consent default à GTM avant le 1er pageview.
initGTM();
initUtm();

// Auto-reload UNIQUEMENT sur l'event Vite-specifique de preload chunk
// echoue (= apres un deploy Netlify, chunks renommes). Pattern :
// sessionStorage marker pour eviter la boucle infinie si le reload echoue.
//
// Note : ne PAS attacher de handler global sur 'error' ou
// 'unhandledrejection' — ça intercepte aussi les erreurs business et peut
// faire flasher la page non-stop.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  const KEY = 'baralambic-chunk-reload';
  if (sessionStorage.getItem(KEY) === 'pending') {
    sessionStorage.removeItem(KEY);
    return; // deja essaye, on stop pour eviter la boucle
  }
  sessionStorage.setItem(KEY, 'pending');
  window.location.reload();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)